module.exports = __webpack_public_path__ + "static/media/СЗФО_2014.cf065999.png";